import axios from "axios";

export const lookup = company => {
  return new Promise(resolve => {
    axios
      .post(this.state.url + "/config/load", {
        company
      })
      .then(res => {
        let { user } = res.data.response.payload;
        resolve(user._id);
      });
  });
};
